






























































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import ModalAdd from './ModalAdd.vue'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { AdditionalModule } from '@/app/store/modules/additionalinfo'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'modal-image': ModalImage,
    'modal-add': ModalAdd,
    'image-select': ImageSelect,
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public id
  @Prop({}) public imageDataCategory
  @Prop({}) public clearRowSelected

  // Property Button Delete All
  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    AdditionalModule.deleteAdditional({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }

  // Property Input Title

  public onPaste(evt) {
    return evt.preventDefault()
  }
}
